import { render, staticRenderFns } from "./ClasificacionDocentePage.vue?vue&type=template&id=a820cd92"
import script from "./ClasificacionDocentePage.js?vue&type=script&lang=js&external"
export * from "./ClasificacionDocentePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports